import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Creatable from "react-select/creatable";
import Cookies from "js-cookie";

const AddOrderDetails = ({
  order_id,
  formRef,
  getData,
  getSingleData,
  size,
  discomId,
}) => {
  const [storeProduct, setStoreProduct] = useState([]);
  const [productName, setProductName] = useState("");
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [rowAddData, setRowAddData] = useState({
    circle: "",
    product_name: "",
    alloted_qty: "",
    gst_percent: 0,
    govt_rate: 0,
  });
  const [circle, setCircle] = useState([]);
  const [region, setRegion] = useState([]);
  const [circleName, setCircleName] = useState("");
  const [regionName, setRegionName] = useState("");
  const [circleRate, setCircleRate] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleProductChange = (e) => {
    setProductName(e.target.value);
  };

  const handleCircleChange = (e) => {
    setCircleName(e ? e.value : "");
  };

  const handleRegionChange = (e) => {
    setRegionName(e ? e.value : "");
  };

  const handleCreateOption = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setCircle((prevCircle) => [...prevCircle, newOption]);
    setCircleName(inputValue);
  };

  const resetFields = () => {
    setRowAddData({
      circle: "",
      product_name: "",
      alloted_qty: "",
      gst_percent: 0,
      govt_rate: 0,
    });
    setStoreProduct([]);
    setProductName("");
    setCircleName("");
    setCircleRate([]);
    setRegionName("");
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { alloted_qty, gst_percent, govt_rate } = rowAddData;
    if (isNaN(alloted_qty) || isNaN(gst_percent) || isNaN(govt_rate)) {
      toast.error("Please enter valid numbers in the required fields!");
      return;
    }
    const BASE_URL = `${SERVER_URL}/api/govt-order/govt-order-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        govt_order_id: order_id,
        circle: circleName,
        region: regionName.region,
        product_name: productName,
        alloted_qty,
        gst_percent,
        rate: govt_rate,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      getSingleData();
      setTimeout(() => {
        resetFields();
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const getProductData = async () => {
    const BASE_URL = `${SERVER_URL}/api/product/all-products-distinct/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStoreProduct(result.data);
    } else {
      setStoreProduct([]);
    }
  };

  useEffect(() => {
    getProductData();
  }, [productName]);

  const getRegion = async () => {
    const BASE_URL = `${SERVER_URL}/api/region/region-list/${user_id}?discom_id=${discomId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      if (result.data?.length > 0) {
        const combinedData = result.data?.map((item) => ({
          value: { region: item.region_name, region_id: item.id },
          label: item.region_name,
        }));
        setRegion(combinedData);
      }
    } else {
      setRegion([]);
    }
  };

  useEffect(() => {
    if (discomId) {
      getRegion();
    }
  }, [discomId]);

  const getCircle = async () => {
    const BASE_URL = `${SERVER_URL}/api/govt-rate/drop-govt-rate-list/${user_id}?region_id=${regionName.region_id}`;
    try {
      const res = await fetch(BASE_URL, {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await res.json();
      if (result?.data?.length > 0) {
        const combinedData = result.data.map((item) => ({
          value: item.circle_name,
          label: item.circle_name,
        }));
        setCircle(combinedData);
      } else {
        setCircle([]);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setCircle([]);
    }
  };

  useEffect(() => {
    if (regionName?.region_id) {
      getCircle();
    }
  }, [regionName?.region_id]);

  const getCircleRate = async () => {
    const BASE_URL = `${SERVER_URL}/api/govt-rate/single-govt-rate/${user_id}?circle_name=${circleName}&product_name=${productName}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCircleRate(result.data);
    } else {
      setCircleRate(null);
    }
  };

  useEffect(() => {
    if (circleName && productName) {
      getCircleRate();
    }
  }, [circleName, productName]);

  useEffect(() => {
    if (circleRate) {
      setRowAddData({ ...rowAddData, govt_rate: circleRate.govt_rate });
    } else {
      setRowAddData({ ...rowAddData, govt_rate: 0 });
    }
  }, [circleRate]);

  return (
    <div
      className="modal custom-modal fade"
      id="exampleModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="imageZoomModalTitle">
              Add RCA Details
            </h5>
            <button
              type="button"
              className="custon-close-button-color close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={resetFields}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body">
                  <form
                    className="form-sample"
                    ref={formRef}
                    onSubmit={handleAddDataSubmit}
                  >
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="alloted">Alloted Quantity</label>
                          <input
                            type="number"
                            className="form-control"
                            name="alloted_qty"
                            id="alloted"
                            required
                            autoComplete="off"
                            value={rowAddData.alloted_qty}
                            placeholder="Alloted Quantity"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="region">Region</label>
                          <Creatable
                            placeholder="Select or add region"
                            onChange={handleRegionChange}
                            onCreateOption={handleCreateOption}
                            options={region}
                            isSearchable
                            isClearable
                            value={
                              region?.find(
                                (item) =>
                                  item.value.region === regionName?.region
                              ) || null
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="circle">Circle</label>
                          <Creatable
                            placeholder="Select or add circle"
                            onChange={handleCircleChange}
                            onCreateOption={handleCreateOption}
                            options={circle}
                            isSearchable
                            isClearable
                            value={
                              circle?.find(
                                (item) => item.value === circleName
                              ) || null
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="size">Size</label>
                          <select
                            type="text"
                            className="form-control form-control-lg"
                            name="product_name"
                            id="size"
                            required
                            onChange={handleProductChange}
                            value={productName}
                          >
                            <option value="">Select Size</option>
                            {size?.map((item, id) => (
                              <option key={id} value={item.size}>
                                {item.size}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="govt">Govt Rate</label>
                          <input
                            type="number"
                            className="form-control"
                            name="govt_rate"
                            required
                            id="govt"
                            placeholder="Govt Rate"
                            value={rowAddData.govt_rate}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group">
                          <label htmlFor="gst_percent">GST %</label>
                          <input
                            type="number"
                            className="form-control"
                            name="gst_percent"
                            required
                            min="0"
                            max="100"
                            title="Please enter a number between 0-100"
                            id="gst_percent"
                            placeholder="Add GST"
                            value={rowAddData.gst_percent}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <button className="btn btn-primary mr-2 mt-3" type="submit">
                      Save
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOrderDetails;
